import { Box, Button, CircularProgress, Typography } from '@mui/material';

interface LoadMoreFooterProps {
  loaded: number;
  total: number | null;
  loading: boolean;
  hasMore: boolean;
  onLoadMore: () => void;
  size?: 'small' | 'medium';
}

/** How much of the list is on screen, and the button that fetches the next page. */
const LoadMoreFooter = ({ loaded, total, loading, hasMore, onLoadMore, size = 'medium' }: LoadMoreFooterProps) => (
  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2, py: 0.5, minHeight: 36 }}>
    {(loaded > 0 || total !== null) && (
      <Typography variant="body2" color="text.secondary">
        {total !== null ? `${loaded} of ${total} loaded` : `${loaded} loaded`}
      </Typography>
    )}
    {loading && <CircularProgress size={20} />}
    {!loading && hasMore && (
      <Button size={size} onClick={onLoadMore}>
        Load more
      </Button>
    )}
  </Box>
);

export default LoadMoreFooter;
